import { Injectable } from '@angular/core';
import { AppConfig } from '../portal/domain/appconfig';

@Injectable({
  providedIn: 'root',
})
export class AppConfigService {
  config: AppConfig = {
    theme: 'lara-light-blue',
    dark: false,
    inputStyle: 'outlined',
    ripple: true,
  };

  private environment: EnvironmentEnum = 'DEV';
  private theme: EnvironmentTheme = 'BACKSPACE';

  get environmentSystem() {
    return this.environment;
  }

  get themeSystem() {
    return this.theme;
  }

  get resellerFttbOrderingEnabled() {
    return ENVIRONMENT_FEATURE_FLAGS[this.environment].resellerFttbOrdering;
  }

  get googleMapsApiKey() {
    return 'AIzaSyAcdt1ywpDqUyKmQvZ-0-f_4CaxBHirdXI';
  }

  constructor() {
    if (window && window.location) {
      const hostname = window.location.host.toLowerCase();
      if (
        hostname.indexOf('localhost') > -1 ||
        hostname.indexOf('127.0.0.1') > -1
      ) {
        this.environment = 'DEV';
      } else if (hostname.indexOf('stage') > -1) {
        this.environment = 'STAGE';
      } else {
        this.environment = 'PROD';
      }

      if (hostname.indexOf('yaxxa') > -1) {
        this.theme = 'YAXXA';
      } else if (hostname.indexOf('klik') > -1) {
        this.theme = 'KLIK';
      } else if (hostname.indexOf('lanline') > -1) {
        this.theme = 'LANLINE';
      } else if (hostname.indexOf('st-cloud') > -1) {
        this.theme = 'STCLOUD';
      } else {
        this.theme = 'BACKSPACE';
      }
    }
  }

  get baseUrl() {
    if (this.environment === 'STAGE') {
      return 'https://backspace-api.stage.backspace.net.za/';
    } else if (this.environment === 'PROD') {
      return 'https://backspace-api.backspace.co.za/';
    } else if (this.environment === 'DEV') {
      return 'https://backspace-api.stage.backspace.net.za/';
      // return 'http://localhost:8080/';
    }
    throw new Error('Not implemented');
  }
}

const Environments = ['DEV', 'STAGE', 'PROD'] as const;

export type EnvironmentEnum = (typeof Environments)[number];

const EnvironmentThemes = [
  'BACKSPACE',
  'YAXXA',
  'KLIK',
  'LANLINE',
  'STCLOUD',
  'REDEFINEIT',
  'MTN',
  'CXP',
] as const;

export type EnvironmentTheme = (typeof EnvironmentThemes)[number];

const ENVIRONMENT_FEATURE_FLAGS: Record<
  EnvironmentEnum,
  { resellerFttbOrdering: boolean }
> = {
  DEV: { resellerFttbOrdering: true },
  STAGE: { resellerFttbOrdering: true },
  PROD: { resellerFttbOrdering: false },
};
